module.exports = __webpack_public_path__ + "static/media/luck.101ff06d.png";